import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { tesaChipBlue, tesaWhite } from "../../styles/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: theme.spacing(3),
      position: "relative",
    },
    advancedSearchButton: {
      color: tesaChipBlue,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    controlsContainer: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column",
      alignItems: "flex-start",
      [theme.breakpoints.up("lg")]: {
        flexWrap: "nowrap",
      },
    },
    filtersSubContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: theme.spacing(2),
    },
    horizContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
    },
    link: {
      color: tesaWhite,
      fontFamily: "Proxima Nova Bold",
      textDecoration: "none",
      "&:hover": {
        color: "rgb(70, 71, 117)",
      },
    },
    marginBottomM: {
      marginBottom: theme.spacing(3),
    },
    marginBottomL: {
      marginBottom: theme.spacing(5),
    },
    searchBar: {
      "& .MuiInputBase-root": {
        fontSize: "14px",
        paddingTop: "0.7rem",
        paddingBottom: "0.7rem",
      },
    },
    viewControlsContainer: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      marginTop: theme.spacing(2),
    },
  }),
);

export default useStyles;
